import { type FC, useEffect } from 'react';

import { APP_DEGRADED_ATTRIBUTE } from 'shared/constants/hydration';

interface ISsrMarkupFallbackProps {
  /** Серверная разметка, снятая до hydrateRoot */
  html: string;
}

/**
 * Заглушка корневого error boundary: возвращает в DOM серверную разметку, чтобы при ошибке после гидрации
 * вместо приложения не оставался пустой <span>. Интерактивность теряется, контент и ссылки остаются
 * (важно для поисковых ботов). display: contents — обёртка не ломает раскладку.
 */
export const SsrMarkupFallback: FC<ISsrMarkupFallbackProps> = ({ html }) => {
  useEffect(() => {
    document.documentElement.setAttribute(APP_DEGRADED_ATTRIBUTE, 'true');
  }, []);

  // oxlint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html }} style={{ display: 'contents' }} />;
};
